import { initializeCookiebot } from 'nike-ui/src/components/cookie';
import { clientLog } from 'nike-ui/src/common/logging/logs';
import { AssetsLoadErrorLog } from 'nike-ui/src/common/logging/AssetsLoadErrorLog';
import { isNativeCasinoGameSession } from '@/casinovegas/nativeCasinoGameSession';

export const initializeCookieBotMobile = () => {
    if (isNativeCasinoGameSession()) {
        return;
    }
    return initializeCookiebot({ channel: 'mobile' }).catch(error => {
        clientLog(
            AssetsLoadErrorLog({
                message: error.message,
                data: {
                    code: error.code,
                    request: error.request
                },
                stacktrace: error.stacktrace || error.stack
            })
        );
    });
};
